// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0 0 0.4rem;
  color: var(--color-text-muted);
  font-size: 0.78rem;
  font-weight: 500;
}

.page-breadcrumb__item--current {
  color: var(--color-text);
}

.page-breadcrumb__separator {
  color: var(--color-text-muted);
  opacity: 0.65;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageBreadcrumb.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf","sourcesContent":[".page-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0 0 0.4rem;\n  color: var(--color-text-muted);\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n.page-breadcrumb__item--current {\n  color: var(--color-text);\n}\n\n.page-breadcrumb__separator {\n  color: var(--color-text-muted);\n  opacity: 0.65;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
